'use strict';

/**
 *  This is a place for shared code across mappers
 */
module.exports = {
    /**
     * This method can map out favorite items and products in the favorite meals.  It is 
     * shared by both of these mappers currently.
     * @param menuModel menuModel with menu data
     * @param favoriteItemProduct favoriteItem's product data from favoriteMeal API
     * @returns {*} DTO that represents some base data around the favoriteItem data that came in
     */
    mapCoreFavoriteItemTo: function mapCoreFavoriteItemTo(menuModel, favoriteItemProduct, menuItemId) {
        //grab sales item by productId
        var salesItem = menuModel.getSalesItemBy(favoriteItemProduct.salesItemId);

        if (!salesItem) {
            //no items may be found, quick exit
            return false;
        }

        var menuItem = menuModel.menuItemById(menuItemId);

        //DID NOT FIND MENU ITEM :(
        if (!menuItem) {
            console.log('did not find menu item');
            return false;
        }

        //modifiers
        var modifiers = [];
        var components = favoriteItemProduct.components;
        if (components && components.length) {
            components.forEach(function (component) {
                var componentId = component.componentId ? component.componentId : menuModel.getModifierById(component.modifierId).componentId;
                modifiers.push({
                    action: component.action,
                    salesItemOptionId: component.modifierId,
                    modifierGroupId: component.modifierGroupId,
                    quantity: component.quantity || 1,
                    componentId: componentId
                });
            });
        }

        return {
            salesItem: salesItem,
            menuItem: menuItem,
            modifiers: modifiers,
            quantity: favoriteItemProduct.quantity
        };
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/mappers/_shared.js
// module id = 844
// module chunks = 0